"use client";

import { useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import Navbar from "./components/navbar";
import FeaturesSection from "./components/features-section";
import Footer from "./components/footer";
import { isMobile } from "react-device-detect";

export const MountainOfMadness = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVideoLoaded(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="tw-min-h-screen tw-bg-white">
      {/* Hero Section with Video Background */}
      <div className="tw-relative tw-h-screen tw-overflow-hidden">
        <div className="tw-absolute tw-inset-0 tw-z-0">
          {isVideoLoaded && (
            <video
              className="tw-object-cover tw-w-full tw-h-full"
              autoPlay
              loop
              muted
              playsInline
            >
              <source
                src="https://d1puf2nnbcyl9q.cloudfront.net/2025-05-09T07:04:20.860Z5579171674651458569.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          )}
        </div>

        <div className="tw-absolute tw-inset-0 tw-bg-black tw-bg-opacity-40 tw-z-10"></div>

        <Navbar />

        <div className="tw-relative tw-z-20 tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-text-white tw-px-4 tw-text-center">
          <img
            src="/images/MOM-logo.png"
            alt="SoFest Logo"
            className="tw-w-64 md:tw-w-80 tw-mb-6"
          />
          <h1 className="tw-text-5xl md:tw-text-7xl tw-font-bold tw-mb-4">
            Party on Top of
            <span className="tw-block tw-text-red-500 tw-font-cursive">
              The World
            </span>
          </h1>
          <p className="tw-text-xl md:tw-text-2xl tw-max-w-3xl tw-mb-0">
            An action-packed week of snow, music and festivities held in
          </p>
          <p className="tw-text-xl md:tw-text-2xl tw-max-w-3xl tw-mb-8">
            Yunding Ski Resort, Beijing
          </p>
          <button
            onClick={() =>
              window.open("https://sotravel.com/trip/1948", "_blank")
            }
            className="tw-bg-red-500 tw-text-white tw-font-bold tw-py-3 tw-px-8 tw-rounded-md tw-text-lg hover:tw-bg-red-600 tw-transition-colors"
          >
            WAITLIST NOW
          </button>

          <div className="tw-absolute tw-bottom-8 tw-animate-bounce">
            <ChevronDown size={32} />
          </div>
        </div>
      </div>

      {/* Experience Section */}
      <section className="tw-py-20 tw-px-4 tw-bg-white">
        <div className="tw-max-w-6xl tw-mx-auto tw-text-center">
          <h2 className="tw-text-4xl md:tw-text-5xl tw-font-bold tw-mb-6">
            Experience the
            <span className="tw-text-[#00bfff] tw-font-cursive"> World </span>
            of
            <span className="tw-text-[#00bfff] tw-font-cursive"> SoFest</span>
          </h2>
          <p className="tw-text-lg tw-text-gray-700 tw-max-w-4xl tw-mx-auto tw-mb-10">
            We're a boutique ski festival inviting adventure and party
            enthusiasts from all over Asia to join us for a week of celebration
            and snow. Experience China's premier ski resort with us, carving
            through pristine slopes and celebrating Aprés style. This is not a
            ski trip - it's a once in a lifetime experience you'll never forget.
          </p>
          <button
            onClick={() =>
              window.open("https://sotravel.com/trip/1948", "_blank")
            }
            className="tw-bg-red-500 tw-text-white tw-font-bold tw-py-3 tw-px-8 tw-rounded-md tw-text-lg hover:tw-bg-blue-600 tw-transition-colors"
          >
            LET'S GO
          </button>
        </div>
      </section>

      {/* Features Section */}
      <FeaturesSection />

      {/* Testimonials/Press Section */}
      <section className="tw-py-10 tw-bg-[#00bfff] tw-overflow-hidden">
        <div className="tw-relative tw-flex tw-overflow-hidden">
          <div className="tw-flex tw-whitespace-nowrap tw-animate-marquee">
            {[
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
            ].map((press, index) => (
              <div
                key={`first-${index}`}
                className="tw-text-white tw-font-bold tw-text-2xl md:tw-text-3xl tw-mx-12"
              >
                {press}
              </div>
            ))}
          </div>
          <div className="tw-flex tw-whitespace-nowrap tw-animate-marquee2">
            {[
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
              "SNOW • MUSIC • ADVENTURE",
            ].map((press, index) => (
              <div
                key={`second-${index}`}
                className="tw-text-white tw-font-bold tw-text-2xl md:tw-text-3xl tw-mx-12"
              >
                {press}
              </div>
            ))}
          </div>
        </div>
        <style jsx>{`
          @keyframes marquee {
            0% {
              transform: translateX(0%);
            }
            100% {
              transform: translateX(-100%);
            }
          }
          @keyframes marquee2 {
            0% {
              transform: translateX(100%);
            }
            100% {
              transform: translateX(0%);
            }
          }
          .tw-animate-marquee {
            animation: marquee 30s linear infinite;
          }
          .tw-animate-marquee2 {
            animation: marquee2 30s linear infinite;
          }
          @media (max-width: 768px) {
            .tw-animate-marquee {
              animation: marquee 20s linear infinite;
            }
            .tw-animate-marquee2 {
              animation: marquee2 20s linear infinite;
            }
          }
        `}</style>
      </section>

      {/* CTA Section */}
      <section className="tw-py-20 tw-px-4 tw-bg-white">
        <div className="tw-max-w-4xl tw-mx-auto tw-text-center">
          <img
            src="/images/MOM-poster.png"
            alt="SoFest - Ski. Sleep. Rave. Repeat."
            className="tw-w-64 tw-mx-auto tw-mb-8"
          />
          <h2 className="tw-text-3xl md:tw-text-4xl tw-font-bold tw-mb-6">
            Ready for the Mountain of Madness?
          </h2>
          <p className="tw-text-lg tw-text-gray-700 tw-mb-8">
            Join us for an unforgettable week of skiing, music, and adventure.
            Book your spot now before tickets sell out!
          </p>
          <button
            onClick={() =>
              window.open("https://sotravel.com/trip/1948", "_blank")
            }
            className="tw-bg-red-500 tw-text-white tw-font-bold tw-py-3 tw-px-8 tw-rounded-md tw-text-lg hover:tw-bg-red-600 tw-transition-colors"
          >
            WAITLIST NOW
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
};
